import React from 'react';

import useAccessGate from '../../hooks/useAccessGate';
import WorkspaceGateOverlay from './AnalyticsWorkspace/WorkspaceGateOverlay';

function DashboardAccessGate({
  children,
  policyId,
  requiredTier,
  active,
  title,
  description,
  ctaLabel,
  onCtaClick,
  previewLabel,
  onPreviewClick,
  variant = 'absolute',
  width = 'min(560px, 92vw)',
}) {
  const access = useAccessGate({ policyId, requiredTier });
  const gateActive = active ?? access.gateActive;

  return (
    <WorkspaceGateOverlay
      active={gateActive}
      title={title || access.title}
      description={description}
      ctaLabel={ctaLabel || access.ctaLabel}
      onCtaClick={onCtaClick || access.upgrade}
      previewLabel={previewLabel}
      onPreviewClick={onPreviewClick}
      variant={variant}
      width={width}
    >
      {children}
    </WorkspaceGateOverlay>
  );
}

export default DashboardAccessGate;
